export default "__VITE_ASSET__DkzRwDp$__"